export default function AuburnHelpfulResourcesSection() {
  const photoLocations = [
    { name: "CVS Pharmacy — Auburn", address: "2415 E University Dr, Auburn, AL 36830", hours: "Daily 7 AM – 10 PM" },
    { name: "Walgreens — Auburn", address: "1717 Opelika Rd, Auburn, AL 36830", hours: "Call for hours" },
    { name: "CVS Pharmacy — Opelika", address: "1619 Pepperell Pkwy, Opelika, AL 36801", hours: "Daily 7 AM – 10 PM" },
    { name: "The UPS Store — Auburn", address: "1550 Opelika Rd Suite 7, Auburn, AL 36830", hours: "Call for hours" },
    { name: "Walgreens — Opelika", address: "2108 Pepperell Pkwy, Opelika, AL 36801", hours: "Call for hours" },
    { name: "FedEx Office — Auburn", address: "205 W Magnolia Ave, Auburn, AL 36830", hours: "Call for hours" },
  ];

  return (
    <section id="local-resources" className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Local Resources</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">Helpful Resources for Auburn Travelers</h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">Getting your passport ready involves more than just the application. Here are local Auburn and Lee County resources to help you gather everything you need.</p>
        </div>
        <div className="space-y-6">
          <div className="bg-white rounded-lg border border-gray-200 overflow-hidden">
            <div className="bg-[#1A365D] px-6 py-5 flex items-center gap-3">
              <div className="w-10 h-10 flex items-center justify-center rounded-full bg-white/15 flex-shrink-0">
                <i className="ri-camera-line text-white text-lg"></i>
              </div>
              <div>
                <p className="text-white/60 text-xs font-semibold uppercase tracking-widest">Passport Photos</p>
                <p className="text-white font-bold text-base leading-tight mt-0.5">Passport Photo Locations Near Auburn</p>
              </div>
            </div>
            <div className="px-6 py-6">
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 mb-4">
                {photoLocations.map((loc, i) => (
                  <div key={i} className="bg-[#F7F8FA] border border-gray-200 rounded-lg p-3.5">
                    <p className="font-bold text-[#1A365D] text-xs leading-snug mb-1">{loc.name}</p>
                    <p className="text-gray-500 text-xs leading-relaxed">{loc.address}</p>
                    <p className="text-gray-400 text-xs mt-1">{loc.hours}</p>
                  </div>
                ))}
              </div>
              <div className="bg-[#F7F8FA] border border-gray-200 rounded-md p-3">
                <p className="text-gray-600 text-xs leading-relaxed">
                  <i className="ri-lightbulb-line text-[#F6C344] mr-1.5"></i>
                  <strong>Tip:</strong> Wear a plain white or off-white top, no glasses, neutral expression. AU students: the campus photo lab is NOT typically set up for U.S. government passport specifications — use a pharmacy or UPS Store.
                </p>
              </div>
            </div>
          </div>
          <div className="bg-white rounded-lg border border-gray-200 overflow-hidden">
            <div className="bg-[#1A365D] px-6 py-5 flex items-center gap-3">
              <div className="w-10 h-10 flex items-center justify-center rounded-full bg-white/15 flex-shrink-0">
                <i className="ri-flight-takeoff-line text-white text-lg"></i>
              </div>
              <div>
                <p className="text-white/60 text-xs font-semibold uppercase tracking-widest">Airports</p>
                <p className="text-white font-bold text-base leading-tight mt-0.5">Airports Serving Auburn Travelers</p>
              </div>
            </div>
            <div className="px-6 py-6">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
                {[
                  { code: "ATL", name: "Atlanta Hartsfield-Jackson International Airport", distance: "About 90 miles west of Auburn via I-85", note: "Primary international gateway for Auburn travelers. Largest airport in the world by passenger volume. Nonstop service to destinations worldwide.", featured: true },
                  { code: "CSG", name: "Columbus Metropolitan Airport", distance: "About 40 miles east of Auburn", note: "Smaller regional airport serving Columbus, GA and Phenix City, AL. Limited commercial routes — most Auburn travelers use ATL for international flights.", featured: false },
                ].map((airport, i) => (
                  <div key={i} className={`rounded-lg p-4 border ${airport.featured ? "bg-amber-50 border-[#F6C344]/40" : "bg-[#F7F8FA] border-gray-200"}`}>
                    <div className="flex items-center gap-2 mb-2">
                      <span className="text-[#1A365D] font-black text-xl leading-none">{airport.code}</span>
                      {airport.featured && <span className="text-xs font-bold text-amber-700 bg-amber-100 px-2 py-0.5 rounded-full">Primary</span>}
                    </div>
                    <p className="font-bold text-[#1A365D] text-xs leading-snug mb-1">{airport.name}</p>
                    <div className="flex items-center gap-1.5 text-xs text-[#F6C344] font-semibold mb-2"><i className="ri-road-map-line"></i><span>{airport.distance}</span></div>
                    <p className="text-gray-400 text-xs leading-relaxed">{airport.note}</p>
                  </div>
                ))}
              </div>
              <div className="bg-amber-50 border border-amber-200 rounded-md p-3">
                <p className="text-gray-600 text-xs leading-relaxed">
                  <i className="ri-passport-line text-amber-500 mr-1.5"></i>
                  <strong>Passport required for all international flights.</strong> If your departure is within two weeks, standard processing will not work — <a href="https://fastpassportcenter.com/checkout/" className="font-bold text-[#1A365D] underline underline-offset-2 hover:text-[#F6C344] transition-colors">expedited processing through Fast Passport Center</a> is your most reliable option.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}